<template>
  <v-app-bar
    app
    dark
    dense
    flat
    color="primary"
  >
    <v-app-bar-nav-icon @click="$root.sidebar.open = ! $root.sidebar.open" />
    <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
    <v-spacer />
    <v-btn
      id="btn-notifications"
      icon
      @click="handleNotificationsButtonClick"
    >
      <v-badge
        v-if="hasUnseenNotifications"
        color="red"
        overlap
        icon="mdi-exclamation-thick"
      >
        <v-icon>mdi-bell-ring-outline</v-icon>
      </v-badge>
      <v-icon v-else>
        mdi-bell-outline
      </v-icon>
    </v-btn>
    <v-btn
      icon
      @click="handleSupportButtonClick"
    >
      <v-icon>mdi-help-circle</v-icon>
    </v-btn>
    <locales-menu>
      <template #activator="{ on, attrs, loading }">
        <v-btn
          :loading="loading"
          :disabled="loading"
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-earth</v-icon>
        </v-btn>
      </template>
    </locales-menu>
    <v-menu
      left
      bottom
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <switch-team-list>
        <v-list-item-group>
          <v-list-item @click="$inertia.visit(route('logout'), { method: 'post' })">
            <v-list-item-title>{{ $t('Logout') }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </switch-team-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      required: true
    }
  },

  computed: {
    hasUnseenNotifications() {
      return this.$page.props.user.notifications.some(
        notification => ! notification.seen
      );
    }
  },

  methods: {
    handleSupportButtonClick() {
      this.$root.showSupportDialog();
    },

    handleNotificationsButtonClick() {
      this.$root.showNotificationsDialog();
    },
  }
}
</script>

<style>
  #btn-notifications .v-badge__badge {
    width: 20px !important;
  }

  #btn-notifications .v-badge__badge i {
    font-size: 12px !important;
    height: 12px !important;
    width: 12px !important;
  }
</style>